import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
interface GoalCardProps {
  title: string;
  subtitle?: string;
  isCompleted: boolean;
  onToggle: () => void;
}
export function GoalCard({
  title,
  subtitle,
  isCompleted,
  onToggle
}: GoalCardProps) {
  return <motion.div whileHover={{
    y: -4,
    scale: 1.01
  }} className={`relative group cursor-pointer overflow-hidden rounded-xl border transition-all duration-300 ${isCompleted ? 'bg-app-card/40 border-app-border/50 opacity-60' : 'bg-app-card border-app-border hover:border-app-accent/50 hover:shadow-[0_0_15px_rgba(249,115,22,0.15)]'}`} onClick={onToggle} data-id="element-42">
      <div className="p-5 flex items-start gap-4" data-id="element-43">
        <div className="flex-shrink-0 mt-1" data-id="element-44">
          <div className={`w-6 h-6 rounded flex items-center justify-center border transition-colors ${isCompleted ? 'bg-app-accent border-app-accent text-white' : 'border-app-border text-transparent group-hover:border-app-accent/50'}`} data-id="element-45">
            <Check size={14} className={isCompleted ? 'opacity-100' : 'opacity-0'} data-id="element-46" />
          </div>
        </div>

        <div className="flex-1 min-w-0" data-id="element-47">
          <div className="flex items-center gap-2 mb-1" data-id="element-48">
            <span className="text-xl leading-none" data-id="element-49">🔥</span>
            <h3 className={`font-syne font-bold text-lg truncate transition-all ${isCompleted ? 'line-through text-gray-500' : 'text-gray-100'}`} data-id="element-50">
              {title}
            </h3>
          </div>
          {subtitle && <p className={`text-sm pl-8 transition-all ${isCompleted ? 'text-gray-600' : 'text-gray-400'}`} data-id="element-51">
              {subtitle}
            </p>}
        </div>
      </div>

      {/* Brutalist accent line */}
      {!isCompleted && <div className="absolute bottom-0 left-0 h-[2px] w-0 bg-app-accent transition-all duration-300 group-hover:w-full" data-id="element-52" />}
    </motion.div>;
}